<template>
  <div class="progress">
    <div class="progress-bg">
      <div class="progress-bg-text" v-if="!isFull">{{ `${cur_kep}/${total_kep}` }}</div>
      <div class="progress-bg-text" v-else>{{ localesPackage?.['katharsis_full_level']?.[localesEnv] }}</div>
      <div class="progress-bg-line" 
          :style="{ 
            width: `${!isFull ? `${Math.floor((cur_kep / total_kep)* 100)}%` : '100%'}`
          }"
      ></div>
    </div>
    <!-- <img
      class="progress-kep"
      :src="require('@/assets/images/YuliApp/weeklyTask/goods_icon_kep@2x.png')"
    /> -->
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import { mapState } from "vuex";

export default {
  components: {},
  props: {
    cur_kep: {
      type: Number,
      default: 0,
    },
    total_kep: {
      type: Number,
      default: 0,
    },
    isFull: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    cur_kep: {
      handler(value) {
        this.curKep = value;
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },

  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
    divWidth: function () {
      const lineWidth = this.progressWidth - this.progressPadding;
      if (this.curKep === 500) {
        const width = "100%";
        return width;
      } else {
        const width =
          (this.curKep / this.total_kep).toFixed(0) + "%";
        return width;
      }
    },
  },
  setup(props, { emit }) {
    const { cur_kep, total_kep } = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const curKep = ref(cur_kep); //保存上一次经验值
    const divWidth = ref(0);
    const progressWidth = ref(0); //移动端适配进度条的宽度
    const progressPadding = ref(0); //进度条的内边距

    onMounted(() => {
      nextTick(() => {
        //获取当前机型进度条宽度
        const progress_el = document.querySelector(".progress");
        progressWidth.value = progress_el.offsetWidth;

        //获取当前机型进度条左右内边距
        const bg_el = document.querySelector(".progress-bg");
        progressPadding.value =
          Number(window.getComputedStyle(bg_el).paddingLeft.replace("px", "")) +
          Number(window.getComputedStyle(bg_el).paddingRight.replace("px", ""));
      });
    });

    /**
     * 计算进度条的宽度
     */
    // const computed = (value, progress_width = 218) => {
    //   if (value === 500) {
    //     divWidth.value = "100%";
    //   } else {
    //     divWidth.value =
    //       ((value * progress_width) / total_kep).toFixed(0) + "px";
    //   }
    // };
    return {
      // divWidth,
      progressPadding,
      curKep,
      progressWidth,
      // computed,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<style lang="less" scoped>
.progress {
  width: 218px;
  height: 26px;
  position: relative;
  top: 94px;
  left: 14px;
  &-bg {
    position: relative;
    box-sizing: border-box;
    // padding: 7px 1px 7px 24px;
    width: 226px;
    height: 13px;
    // background-color: rgba(33, 8, 71, 0.4);
    background: rgba(84, 73, 157, 0.87);
    border-radius: 20px;
    // border: 1px solid rgb(0, 0, 0);
    // background: url("~@/assets/images/YuliApp/weeklyTask/jindu.svg") no-repeat
    //   top left;
    // background-size: 100% 100%;
    &-text {
      height: 26px;
      position: absolute;
      top: -1px;
      left: 10px;
      // color: rgba(0, 0, 0, 1);
      // color: rgba(16, 12, 96, 1);
      color: #fff;
      // -webkit-text-stroke: #100C60 1px;
      font-size: 14px;
      font-weight: 600;
      // font-family: "Josefin Sans";
      font-family: "PingFang SC";
      text-align: center;
      // line-height: 27px;
      text-shadow: 0 1px #100C60, 1px 0 #100C60, -1px 0 #100C60, 0 -1px #100C60;
    }
    &-line {
      height: 13px;
      // background: rgba(137, 158, 221, 1);
      // background: rgba(255, 220, 36, 1);
      background: rgba(255, 255, 255, 1);
      border-radius: 20px;
      transition: all 1s;
    }
  }
  &-kep {
    position: absolute;
    top: -9.18px;
    left: -10px;
    width: 44px;
    height: 44px;
  }
}
</style>
